import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfigService } from '@sphere/platform';

let endpointMap: Map<string, string>;

export const bearerTokenInterceptor: HttpInterceptorFn = (req, next) => {
    const config = inject(AppConfigService);

    let nextReq: HttpRequest<any> = req;
    if (req.url.startsWith('api/') || req.url.startsWith('/api/')) {
        updateEndpointMap(config.apiServerUrl); // this.urlRedirectDictionary will be undefined when we call this from OnInit

        const tokens = req.url.split('/');
        const path = tokens[0] === '' ? tokens[2] : tokens[1];
        const replacedPath = endpointMap.get(path) || config.apiGatewayUrl?.replace(/\/$/, '');

        if (req.url.startsWith('api/')) {
            nextReq = req.clone({ url: `${replacedPath}/${req.url}` });
        } else if (req.url.startsWith('/api/')) {
            nextReq = req.clone({ url: `${replacedPath}${req.url}` });
        }
    } else if (req.url.startsWith('/api-nexus-2/') || req.url.startsWith('api-nexus-2/')) {
        const replacedPath = config.apiGatewayNexus2Url?.replace(/\/$/, '');
        if (req.url.startsWith('/api-nexus-2/')) {
            nextReq = req.clone({ url: `${replacedPath}/${req.url.replace('/api-nexus-2/', '')}` });
        } else if (req.url.startsWith('api-nexus-2/')) {
            nextReq = req.clone({ url: `${replacedPath}${req.url.replace('api-nexus-2/', '')}` });
        }
    }

    return next(nextReq);
};

/**
 * This method expects a string in the following format
 * default=https://url.com,curve=https://curve.com,dhws=https://curve.url
 *  for testing we shall use default= http://localhost:4200
 */
function updateEndpointMap(apiServerUrl: string): Map<string, string> {
    if (endpointMap?.size > 0) {
        return endpointMap;
    }

    console.debug(`Initializing endpoint map from ${apiServerUrl}`);
    endpointMap = new Map<string, string>();

    const urlMaps = apiServerUrl.split(',');
    console.debug(`found ${urlMaps.length} url maps`);
    urlMaps.forEach(m => {
        console.debug(`splitting url map ${m}`);
        const parts = m.split('=');
        if (parts.length === 2) {
            console.debug(`Adding ${parts[0]} with value ${parts[1]}`);
            endpointMap.set(parts[0], parts[1]);
        } else {
            console.error('Invalid urlMap entry found, should be in format /api/xxx=http://targetUrl/api/xxx');
        }
    });

    if (!endpointMap.get('default')) {
        throw new Error(
            'apiServerUrl environment key is incorrectly configured, expecting: default=https://url.com,curve=https://curve.com,dhws=https://curve.url'
        );
    }
}
